export type Driver = {
  id: string;
  name: string;
  picture: string;
  employeeId: string;
};

export type TokenResponse = {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  scope: string;
  session_state: string;
  token_type: string;
};

export enum LogoutReasons {
  Manual = "manual",
  TokenExpired = "tokenExpired",
}
